import { Environments } from '@/config';
import { HELIX_STAGING } from './helix.staging';
import { HELIX_PRODUCTION } from './helix.production';

export const HELIX = import.meta.env.MODE === Environments.PROD ? HELIX_PRODUCTION : HELIX_STAGING;
